export const getSetting = (collection, slug) =>
  collection?.find((s) => s.slug === slug);

export const getSettingLabel = (collection, slug) => {
  const setting = getSetting(collection, slug);
  return setting?.displayName || setting?.enDisplayName;
};
